import { convertESTToLocalTime, getLabelFromDateTime } from '@/utilz';
import Paper from '@/views/components/Paper/Paper';
import TMSFiledCard from '@/views/screens/common/components/TMSFiledCard';
import { Col, Row } from 'antd';

const LADEmailStatusCard = ({ data }) => {
  return (
    <Paper className="mb-15 p-10" border>
      <Row gutter={10}>
        <Col sm={2}>
          <TMSFiledCard title="Claim Key">{data.claimKey}</TMSFiledCard>
        </Col>
        <Col sm={4}>
          <TMSFiledCard title="Senders Email">{data.sendersEmail}</TMSFiledCard>
        </Col>
        <Col sm={4}>
          <TMSFiledCard title="Recipient">{data.recipient}</TMSFiledCard>
        </Col>
        <Col sm={3}>
          <TMSFiledCard title="Sent On">{getLabelFromDateTime(convertESTToLocalTime(data.sentOn))}</TMSFiledCard>
        </Col>
        <Col sm={4}>
          <TMSFiledCard title="Email Subject">{data.emailSubject}</TMSFiledCard>
        </Col>
        <Col sm={2}>
          <TMSFiledCard title="Status Desc">{data.statusDesc}</TMSFiledCard>
        </Col>
        <Col sm={2}>
          <TMSFiledCard title="Description">{data.description}</TMSFiledCard>
        </Col>
        <Col sm={2}>
          <TMSFiledCard title="Date Time Of Action">{data.dateTimeOfAction}</TMSFiledCard>
        </Col>
      </Row>
    </Paper>
  );
};

export default LADEmailStatusCard;
